/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Searchcollaborators1Inputs */

const en_common_searchcollaborators1 = /** @type {(inputs: Common_Searchcollaborators1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Collaborators`)
};

/**
* | output |
* | --- |
* | "Search Collaborators" |
*
* @param {Common_Searchcollaborators1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_searchcollaborators1 = /** @type {((inputs?: Common_Searchcollaborators1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Searchcollaborators1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_searchcollaborators1(inputs)
});
export { common_searchcollaborators1 as "common_searchCollaborators" }